import React from "react";

const ArrowRightIcon = ({
    className
}) => {
    return (
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className || ''}>
            <g id="arrow_back">
                <mask id="mask0_850_1420" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="16">
                    <rect id="Bounding box" width="16" height="16" transform="matrix(-1 0 0 1 16.5 0)" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_850_1420)">
                    <path id="arrow_back_2" d="M11.284 8.66663L7.55065 12.4L8.50065 13.3333L13.834 7.99996L8.50065 2.66663L7.55065 3.59996L11.284 7.33329H3.16732V8.66663H11.284Z" fill="currentColor" />
                </g>
            </g>
        </svg>
    );
};

export default ArrowRightIcon;
